document.querySelectorAll('p iframe').forEach((iframe) => {
	const p = iframe.parentElement;
	if (!p) {
		return;
	}

	p.style.position = 'relative';
	p.style.paddingBottom = '56.25%';
	p.style.height = '0';
	p.style.overflow = 'hidden';
});
